import { Grid } from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import { useChangeAvatarMutation } from '../../api/authApiSlice';
import FormikButton from '../../components/formik/FormikButton';
import Screen from '../../components/fragments/Screen';
import ProfileImageUpload from '../../components/ui/ProfileImageUpload';
import Form from '../../components/utilities/Form';
import { useDispatch } from '../../store';
import { setUser } from '../../store/slices/authSlice';
import errorSnackbar from '../../utils/errorSnackbar';

const validate = Yup.object().shape({
    image: Yup.mixed().required().label('Profile Image'),
});

export default function ChangeAvatarScreen() {
    const [updateReady, setUpdateReady] = useState(false);

    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const state = useSelector((st) => st);
    const { user } = state.auth;

    const [changeAvatar, { isLoading }] = useChangeAvatarMutation();

    return (
        <Screen authPass title="Change Avatar">
            <Grid item xs={12}>
                <div className="d-flex  flex-column">
                    <Form
                        validationSchema={validate}
                        onSubmit={async (vals) => {
                            const { error, data } = await changeAvatar(vals);

                            errorSnackbar(error, enqueueSnackbar);

                            if (data) {
                                dispatch(setUser(data?.data));
                                enqueueSnackbar('Avatar changed successfully.');
                            }
                        }}
                        initialValues={{ image: '' }}
                    >
                        <div style={{ paddingBottom: 10 }}>
                            <ProfileImageUpload
                                style
                                name="image"
                                setUpdateReady={(val) => setUpdateReady(val)}
                                alt={user?.firstName}
                                placeholder={user?.links?.avatar}
                                label="Upload Kanisa Profile Pic"
                            />
                        </div>
                        {updateReady && (
                            <FormikButton
                                variant="contained"
                                loading={isLoading}
                            >
                                Change Profile Pic
                            </FormikButton>
                        )}
                    </Form>
                </div>
            </Grid>
        </Screen>
    );
}
